import templateUrl from './manage-account-settings-container.component.html'

export const ManageAccountSettingsContainerComponent = {
    templateUrl,
    bindings: {
        toast: "<",
        validTil: "<"
    },
    controller: class ManageAccountSettingsContainerComponent {
        constructor(employeeService, utilityService, apexDeployStage) {
            'ngInject';
            this.employeeService = employeeService;
            this.utilityService = utilityService;
            this.apexDeployStage = apexDeployStage;
        }

        $onInit() {
            const identityLoaded = this.employeeService.retrieveIdentity()
                .then(identity => {
                    this.identity = identity;
                    this.hideChangePasswordMenu = this.apexDeployStage === 'Training' && !this.identity.IsSiteAdmin;
                    return identity;
                });
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(identityLoaded, "Initial load failed")
            );
        }
    }
}
